module.exports = __webpack_public_path__ + "571a47da7f327becea2fd66bcc8803f7.svg";